import React from 'react';
import { replaceWithExamples } from '../utils/templateVariables';
import './EmailPreview.css';

const EmailPreview = ({ subject, body, companyLogoUrl, companyName, showSubject = true }) => {
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  const previewSubject = replaceWithExamples(subject || '');
  const previewBody = replaceWithExamples(body || '');

  // Create logo HTML if company logo exists
  const logoHtml = companyLogoUrl ? `
    <div style="text-align: center; margin-bottom: 30px;">
      <img src="${companyLogoUrl}" alt="${companyName || 'Company Logo'}" style="max-width: 200px; max-height: 80px; object-fit: contain;">
      ${companyName ? `<p style="margin: 8px 0 0 0; font-size: 18px; font-weight: 600; color: #333;">${companyName}</p>` : ''}
    </div>
  ` : '';

  // Add logo to the body if it exists
  const bodyWithLogo = companyLogoUrl ? logoHtml + previewBody : previewBody;
  const rawBodyWithLogo = companyLogoUrl ? logoHtml + (body || '') : (body || '');

  return (
    <div className="email-preview">
      <div className="email-preview__toolbar">
        <div className="email-preview__heading">
          <span className="email-preview__title">Email preview</span>
          <span className="email-preview__subtitle">Using sample appointment details</span>
        </div>
        <button
          type="button"
          className="email-preview__copy"
          onClick={() => copyToClipboard(rawBodyWithLogo)}
        >
          Copy template HTML
        </button>
      </div>

      {showSubject ? (
        <div className="email-preview__subject">
          <strong>Subject:</strong> {previewSubject}
        </div>
      ) : null}

      <div className="email-preview__body">
        <div dangerouslySetInnerHTML={{ __html: bodyWithLogo }} />
      </div>
    </div>
  );
};

export default EmailPreview; 